import { createStore, applyMiddleware } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer, { GlobalState } from "./RootReducer";
import { useSelector, EqualityFn, TypedUseSelectorHook } from "react-redux";

const store = configureStore({ reducer: rootReducer });

export type AppState = ReturnType<typeof rootReducer>;
export default store;

// develop only
if (window.location.href.includes("localhost")) {
  (window as any).store = store;
}
